export default __webpack_public_path__ + "static/media/background.2fe341c1.svg";